import { createEndpoint } from "../createEndpoint";
import type { HttpClient, QueryParams } from "../httpClient";
import {
    ExpertClaimResponseSchema,
    ResendExpertClaimVerificationResponseSchema,
    type ExpertClaimResponse,
    type ResendExpertClaimVerificationRequest,
    type ResendExpertClaimVerificationResponse,
    type SubmitExpertClaimRequest,
    type VerifyExpertClaimRequest,
} from "../schemas/expert-claims";

export function createPublicExpertClaimsApi(http: HttpClient, baseUrl: string) {
    return {
        submit: createEndpoint<
            ExpertClaimResponse,
            SubmitExpertClaimRequest,
            QueryParams,
            { slug: string }
        >(http, "POST", "/expert-profiles/:slug/claims", {
            base: baseUrl,
            responseSchema: ExpertClaimResponseSchema,
            params: ["slug"],
        }),

        verify: createEndpoint<ExpertClaimResponse, VerifyExpertClaimRequest>(http, "POST", "/expert-claims/verify", {
            base: baseUrl,
            responseSchema: ExpertClaimResponseSchema,
        }),

        resendVerification: createEndpoint<
            ResendExpertClaimVerificationResponse,
            ResendExpertClaimVerificationRequest
        >(http, "POST", "/expert-claims/resend-verification", {
            base: baseUrl,
            responseSchema: ResendExpertClaimVerificationResponseSchema,
        }),
    };
}

export type PublicExpertClaimsApi = ReturnType<typeof createPublicExpertClaimsApi>;
